import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const patientEligibilityNoteService = {
  basePath: organizationId =>
    `${clinicalApiPath}/organizations/${organizationId}/patient-eligibility-note`,

  getNotes(orgId, patientId, trialId, cancelToken = null) {
    return viperApi.get(this.basePath(orgId), {
      params: { patientId: patientId, trialId: trialId },
      paramsSerializer: function(params) {
        return qs.stringify(params)
      },
      cancelToken
    })
  },

  createNote(orgId, note) {
    return viperApi.post(this.basePath(orgId), note)
  },

  deleteNote(orgId, noteId) {
    return viperApi.delete(`${this.basePath(orgId)}/${noteId}`)
  }
}
